import {CompanyUpsertFormBaseState} from "features/forms/company-upsert";

export const Company = {
    fromServer: (company) => {
        const info = company.info;
        const addresses = company.addresses || [];
        return {
            ...CompanyUpsertFormBaseState,
            id: company.id,
            name: company.business_name,
            shortName: company.short_name,
            vat: company.vat_code,
            adeCode: company.dest_code,
            creationYear: info.birth_year,
            employees: info.employees,
            osaCenter: info.osa_hq,
            referenceSector: info.sector,
            address: addresses.map(i => ({
                address: i.address,
                type: i.type,
                zip: i.zipcode,
                province: i.province,
                country: i.country
            })),
            phone: company.phone,
            email: company.email,
            twitter: info.twitter,
            linkedin: info.linkedin,
            website: info.site,
            description: info.description,
            logo: info.logo,
            document: info.document,
            video: info.video_link,
            skills: info.skills || [],
            skills_raw: Object.values(company.skills || {}),
            products: info.products || [],
            secretCode: company.security_code,
            associates: company.associates,
            role: company.role,
            created_at: company.created_at
        }
    },
    toServer: (company) => {
        return {
            id: company.id,
            business_name: company.name,
            short_name: company.shortName,
            vat_code: company.vat,
            dest_code: company.adeCode,
            email: company.email,
            phone: company.phone,
            secret_code: company.secretCode,
            role: company.role,
            info: {
                birth_year: company.creationYear,
                employees: company.employees,
                osa_hq: company.osaCenter,
                sector: company.referenceSector,
                skills: company.skills,
                linkedin: company.linkedin,
                twitter: company.twitter,
                site: company.website,
                description: company.description,
                video_link: company.video,
                products: company.products
            },
            addresses: (company.address || []).map(i => ({
                type: i.type,
                address: i.address,
                zipcode: i.zip,
                province: i.province,
                country: i.country
            })),
            associates: company.associates
        }
    }
}